import React, { useState, useEffect } from 'react'
import Header from "components/Headers/Header.js";
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import axios from 'axios'
import { Card, CardHeader, CardBody, Container, Row, Col, Spinner, Button, CardFooter } from "reactstrap";
import { useParams, useNavigate, Link } from 'react-router-dom';

function DamageDelete() {
  
  const [loading, setLoading] = useState(true)
  const [loadingsubmit, setLoadingsubmit]=useState(true)

  const [date, setDate] = useState('')
  const [type_damage, setType_damage] = useState('')
  const [text_damage, setText_damage] = useState('')
  const [sensor, setSensor] = useState('')

  const navigate = useNavigate()

  const token = useSelector((state) => state.userLogin.userInfo.token);

  const { fieldId } = useParams()

  ////////////
  const { t, i18n } = useTranslation();  

  useEffect(() => {
    const storedLanguage = localStorage.getItem('selectedLanguageAFS');
    if (storedLanguage) {
      i18n.changeLanguage(storedLanguage);
    }
  }, [i18n]);
  ////////////

  useEffect(() => {

    const fetchData = async () => {

      try {
        const config = {
          headers: {
            'Content-type': 'application/json',
            Authorization: `Bearer ${token}`
          }
        }
        
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_API}/insurance/detail-damage/${fieldId}`, config);

        setDate(response.data.date)
        setType_damage(response.data.type_damage)
        setText_damage(response.data.text_damage)
        setSensor(response.data.sensor)

      } catch (error) {
          
        console.log(error)

      } finally {
        setLoading(false)
      }
    };

    fetchData(); 
  }, [token]);

  const submit = async(e) => {

    setLoadingsubmit(false)

    try {

      const config = {
        headers: {
          'Content-type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      }
      
      await axios.delete(`${process.env.REACT_APP_BACKEND_API}/insurance/delete-damage/${fieldId}/`, config);

    } catch (error) {
        
      console.log(error)

    } finally {
      setLoadingsubmit(false)
      navigate("/damage/")
    }

  }

  return (

    <div>
      <Header/>
      {loading ? (
        <>
          <Container className="mt--15" fluid>
            <Row>
              <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="text-center mt-5">
                <Spinner>
                  {t('Loading')}
                </Spinner>
              </Col>
            </Row>
          </Container>
        </>
      ):(
        <>
          <Container className="mt--15" fluid>
            <Row>
              <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="text-center mt-5">
                <Card>
                  <CardHeader>
                    <h3>{t('Are you sure to delete this damage report?')}</h3>
                  </CardHeader>
                  <CardBody>
                    <ul>
                      <li>{t('Date')} {" "} {date}</li>
                      <li>{t('Type of Damage')} {" "} {type_damage}</li>
                      <li>{t('Note of Damage')} {" "} {text_damage}</li>
                      <li>{t('Sensor')} {" "} {sensor}</li>
                    </ul>
                  </CardBody>
                  <CardFooter>
                    <Row>
                      {loadingsubmit ? (
                        <>
                          <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6} className="text-center mt-5">
                            <Button color="danger" onClick={submit}>
                              {t('Delete Damage Report')} <i className="fa-solid fa-trash"></i>
                            </Button>
                          </Col>
                        </>
                      ) : (
                        <>
                          <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6} className="text-center mt-5">
                            <Button color="danger" disabled>
                              <Spinner size="sm">
                                {t('Deleting...')}
                              </Spinner>
                              <span>
                                {' '}{t('Deleting...')}
                              </span>
                            </Button>
                          </Col>
                        </>
                      )}
                      <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6} className="text-center mt-5">
                        <Link to="/damage/">
                          <Button color="primary">
                            {t('Go back')} <i className="fas fa-rotate-left"></i>
                          </Button>
                        </Link>
                      </Col>
                    </Row>
                  </CardFooter>
                </Card>
              </Col>
            </Row>
          </Container>
        </>
      )}
    </div>
  )
}

export default DamageDelete
